/**
 * Color design tokens for the RPG project.
 * All colors are defined in both hex (for Phaser) and string format (for CSS).
 * Updated to match RPG aesthetic with cyan borders and friendly colors.
 */
export const ColorTokens = {
    // Primary Colors - Dark teal/blue backgrounds
    primary: {
        hex: 0x1a4a5a,
        string: "#1a4a5a",
        description: "Primary brand color, used for backgrounds and containers",
    },
    primaryLight: {
        hex: 0x2d6a7a,
        string: "#2d6a7a",
        description: "Lighter shade of primary - for hover states",
    },
    primaryDark: {
        hex: 0x0d2a35,
        string: "#0d2a35",
        description: "Darker shade of primary - for depth",
    },

    // Text Colors
    text: {
        primary: { hex: 0xffffff, string: "#ffffff" },
        secondary: { hex: 0xcccccc, string: "#cccccc" },
        selected: { hex: 0x5dd9ff, string: "#5dd9ff" }, // Light cyan for selection
        label: { hex: 0x7dbbcc, string: "#7dbbcc" }, // Muted cyan for labels
        disabled: { hex: 0x666666, string: "#666666" },
        error: { hex: 0xff4444, string: "#ff4444" },
        success: { hex: 0x44ff44, string: "#44ff44" },
    },

    // UI Element Colors - RPG style with muted cyan/teal accents
    ui: {
        border: { hex: 0x4a9fb5, string: "#4a9fb5" }, // Muted cyan-teal border
        borderGlow: { hex: 0x6db5c5, string: "#6db5c5" }, // Lighter cyan-teal for glow
        borderDark: { hex: 0x2a5a6a, string: "#2a5a6a" }, // Dark teal
        background: { hex: 0x1a2a30, string: "#1a2a30" }, // Very dark blue-gray
        backgroundLight: { hex: 0x3a4a50, string: "#3a4a50" }, // Medium gray-brown
        backgroundDark: { hex: 0x0a1518, string: "#0a1518" }, // Very dark blue
        overlay: { hex: 0x000000, string: "#000000" },

        // Button-specific backgrounds
        buttonDefault: { hex: 0x3a5045, string: "#3a5045" }, // Darker olive-green tint
        buttonHover: { hex: 0x4a8090, string: "#4a8090" }, // Muted cyan tint
        buttonSelected: { hex: 0x5aa5b5, string: "#5aa5b5" }, // Muted bright cyan
    },

    // Accent Colors
    accent: {
        cyan: { hex: 0x00e5ff, string: "#00e5ff" },
        cyanLight: { hex: 0x5dd9ff, string: "#5dd9ff" },
        yellow: { hex: 0xffdd44, string: "#ffdd44" },
        green: { hex: 0x44cc44, string: "#44cc44" },
        greenDark: { hex: 0x2a6a3a, string: "#2a6a3a" },
        red: { hex: 0xff4444, string: "#ff4444" },
        teal: { hex: 0x00b5cc, string: "#00b5cc" },
    },

    // Semantic Colors
    semantic: {
        info: { hex: 0x00e5ff, string: "#00e5ff" },
        warning: { hex: 0xffaa00, string: "#ffaa00" },
        error: { hex: 0xff4444, string: "#ff4444" },
        success: { hex: 0x44cc44, string: "#44cc44" },
    },
};

export type ColorToken = keyof typeof ColorTokens;
